import React, { createContext, useState } from 'react';

export interface IPanelValues {
  isExpExpanded: boolean;
  setIsExpExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

const initialPanelValues = {
  isExpExpanded: true,
  setIsExpExpanded: () => null,
};

export const PanelContext = createContext<IPanelValues>(initialPanelValues);

export const PanelProvider = ({ children }: { children: React.ReactNode }) => {
  const [isExpExpanded, setIsExpExpanded] = useState(initialPanelValues.isExpExpanded);
  return (
    <PanelContext.Provider value={{ isExpExpanded, setIsExpExpanded }}>
      {children}
    </PanelContext.Provider>
  );
};
